import { render, staticRenderFns } from "./StatisticsBarCardPayment.vue?vue&type=template&id=8bd354e0&"
import script from "./StatisticsBarCardPayment.vue?vue&type=script&lang=js&"
export * from "./StatisticsBarCardPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports